import request from '@/global/request'
import { AxiosResponse } from 'axios'
import { ResponseData } from '@/types/api/public'

type ConfigType<T = ResponseData> = Promise<AxiosResponse<T>>

/**
 * @FunctionName: 根据人员ID获取人员信息
 * @param {string} employeeId
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-10-11 11:20:49
 * @Description: 
 */
export const getEmpOrgStationById = (employeeId: string): ConfigType<any> => {
  return request({
    'url': 'biganalysis-rest/api/getEmpOrgStationById',
    'method': 'post',
    'headers': { 'languageValue': localStorage.getItem('lang') },
    'data': { 'id': employeeId }
  });
}



